/**
 * Whether this document is somebody else's frame.
 *
 * Most of the app does not care, and the embed player positively depends on
 * being framed. Two pages do care: approving a device and handing the desktop
 * app its code are decisions where the surrounding page could lie about what
 * is being approved, position a transparent frame over a real one, or simply
 * not be visible at all. Those two refuse to render rather than trust it.
 *
 * Reading `window.top` across origins throws, and an attacker's frame is
 * exactly the cross-origin case, so the throw is the answer rather than an
 * error worth handling.
 */
export function isFramed(): boolean {
  try {
    return window.top !== window.self;
  } catch {
    return true;
  }
}
